'use client'
import * as React from 'react'
import { LazyMotion, domAnimation, AnimatePresence, m } from 'framer-motion'
import { useIsUserAllAccessTrialingQuery } from '@repo/cf-user/hooks/use-user-data'
import { tw } from 'utils/classnames'

interface YearlyBannerSectionProps extends React.PropsWithChildren {
  children: React.ReactNode
}

export function YearlyBannerSection({ children }: YearlyBannerSectionProps) {
  const { data: isAllAccesssTrial, isPending } = useIsUserAllAccessTrialingQuery()
  const [showYearlyBanner, setShowYearlyBanner] = React.useState(false)

  React.useEffect(() => {
    // oxlint-disable-next-line unicorn/prefer-query-selector
    const element = document.getElementById('enable-bottom-floating-banner')
    if (!element) {
      return
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry) {
        return
      }
      setShowYearlyBanner(!entry.isIntersecting && entry.boundingClientRect.top <= 0)
    })

    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  const animationSettings = { y: '0%' }

  return (
    <section className="m-auto flex w-full justify-center">
      <LazyMotion features={domAnimation}>
        <AnimatePresence>
          {isAllAccesssTrial && !isPending && showYearlyBanner ? (
            <m.div
              animate={animationSettings}
              initial={{ y: '100%' }}
              exit={{ y: '100%' }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              className={tw('fixed bottom-0 z-10 m-auto flex w-full')}
            >
              {children}
            </m.div>
          ) : null}
        </AnimatePresence>
      </LazyMotion>
    </section>
  )
}
